import { fetchCatch } from 'src/core/sentry';

/**
 * Handles bad HTTP responses by logging the error and throwing a formatted error message
 *
 * @param {Response} response - The HTTP Response object that indicates a failure
 * @throws {Error} - Throws an error with formatted message containing status code and text
 */
const handleBadResponse = (response: Response) => {
  fetchCatch(response);
  throw new Error(`HTTP error! status: ${response.status} ${response.statusText}`);
};
export default handleBadResponse;
